import React from 'react';
import {Collapse} from "@blueprintjs/core";
import {
  ThongTinNguoiDungDon,
  ThongTinDonVuViec,
  ThongTinCoQuanDaGiaiQuyet,
  ThongTinNguoiUyQuyen
} from './letter-detail';
import { ShowIf } from 'components/utils';

export default class LetterDetail extends React.Component {
  render() {
    return (
      <div className="wrap-blocks">
        <Collapse isOpen={this.props.isOpen}>
          <ThongTinNguoiDungDon
            title="Thông tin người đứng đơn/Vụ việc"
            parent={this.props.parent}
          />
        </Collapse>
        <ShowIf condition={this.props.parent.coUyQuyen && this.props.isOpen}>
          <div className="pl5 pr5 pt0 mb15"><div className="line-border"></div></div>
            <div className={this.props.isOpen ? "box-items" : "box-items no-margin"}>
              <ThongTinNguoiUyQuyen
                title="Thông tin người được ủy quyền"
                isOpen={this.props.isOpen}
                parent={this.props.parent}
              />
            </div>
            <div className="pl5 pr5 pt0 mb15"><div className="line-border"></div></div>
        </ShowIf>
        <div className={this.props.isOpen ? "box-items" : "box-items no-margin"}>
          <ThongTinDonVuViec
            checkXLDC={this.props.checkXLDC}
            title="Thông tin đơn/Vụ việc"
            isOpen={this.props.isOpen}
            parent={this.props.parent}
          />
        </div>
        <ShowIf condition={this.props.parent.coThongTinCoQuanDaGiaiQuyet && this.props.isOpen }>
          <div className="pl5 pr5 pt0 mb15"><div className="line-border"></div></div>
            <div className={this.props.isOpen ? "box-items" : "box-items no-margin"}>
              <ThongTinCoQuanDaGiaiQuyet
                title="Thông tin cơ quan đã giải quyết"
                isOpen={this.props.isOpen}
                parent={this.props.parent}
              />
            </div>
        </ShowIf>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/letter-information/LetterDetail.jsx